export default __webpack_public_path__ + "static/media/eminem.053ae224.jpg";